import React from 'react'

const Loader = () => {
  return (
    <div className=' w-full h-screen bg-richblack-800'>
        Loading...
    </div>
  )
}

export default Loader
